import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import cn from 'classnames';
import createStyles from "../createStyles";
export var useStyles = createStyles(function (theme) {
  return {
    customArrowButton: {
      padding: theme.spacer(1)
    },
    customArrowButtonEmpty: {
      color: theme.palette.border
    }
  };
}, {
  name: 'CustomArrowIcon'
});

var CustomArrowIcon = function CustomArrowIcon(_ref) {
  var isInputEmpty = _ref.isInputEmpty;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: cn(classes.customArrowButton, _defineProperty({}, classes.customArrowButtonEmpty, isInputEmpty)),
    "data-qa": "custom-arrow-icon"
  }, "-");
};

export default CustomArrowIcon;